<template>
  <section id="sbs-1161">
    <div class="cs-container">
      <!-- Image Group -->
      <div class="cs-image-group">
        <!-- Top Left Image -->
        <picture class="cs-picture cs-picture1">
          <source media="(max-width: 600px)" :srcset="image1">
          <source media="(min-width: 601px)" :srcset="image1">
          <img loading="lazy" decoding="async" :src="image1" alt="appliance" width="630" height="390">
        </picture>

        <!-- Bottom Right Image -->
        <picture class="cs-picture cs-picture2">
          <source media="(max-width: 600px)" :srcset="image2">
          <source media="(min-width: 601px)" :srcset="image2">
          <img loading="lazy" decoding="async" :src="image2" alt="appliance" width="461" height="300">
        </picture>

        <!-- Splash Graphic -->
        <img class="cs-graphic cs-graphic1" loading="lazy" decoding="async" :src="graphic1" alt="splash" width="1154" height="505" aria-hidden="true">

        <!-- Tire Mark -->
        <img class="cs-graphic cs-graphic2" loading="lazy" decoding="async" :src="graphic2" alt="tire mark" width="1085" height="322" aria-hidden="true">

        <!-- Box with Statistics -->
        <div class="cs-box">
          <span class="cs-number">NDIS</span>
          <span class="cs-desc">Registered</span>
        </div>
      </div>

      <!-- Content Section -->
      <div class="cs-content">
        <span class="cs-topper">Who We Are</span>
        <h2 class="cs-title">Excellence in Care, Dignity in Life</h2>
        <p class="cs-text">
          At Ajonee Disability Support Services, we are committed to empowering individuals with disabilities by providing compassionate, personalized, and high-quality support. Our vision is to foster independence, dignity, and inclusion, ensuring that every individual has the choice and opportunity to live a fulfilling life.
By prioritizing individual choice, community inclusion, and innovative support, we create a nurturing environment where our participants can thrive. Our dedicated team is driven by compassion, respect, and a commitment to making a meaningful impact in the lives of those we support.

We specialize in a wide range of NDIS-registered services, including:
        </p>
        
        <!-- Dynamic Feature List -->
        <ul class="cs-ul">
          <li v-for="(feature, index) in features" :key="index" class="cs-li">
            {{ feature }}
          </li>
        </ul>

        <a href="/services" class="cs-button-solid">Explore Our Services</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "WhoWeAreSection",
  data() {
    return {
      image1: require("@/assets/images/abouts-1.jpg"),
      image2: require("@/assets/images/abouts-2.jpg"),
      graphic1: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Graphics/splash-4.svg",
      graphic2: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Graphics/tire-mark.svg",
      features: [
        "Daily Personal Activities & Assistance",
        "Travel & Transport Support",
        "Community & Social Participation",
        "Household Task Assistance",
        "Community Nursing Care"
      ]
    };
  }
};
</script>

<style scoped>
/*-- -------------------------- -->
<---       Side By Side         -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
    #sbs-1161 {
        padding: var(--sectionPadding);
        /* clips grpahics from causing overflow issues */
        overflow: hidden;
        background-color: #f7f7f7;
    }
    #sbs-1161 .cs-container {
        width: 100%;
        /* changes to 1280px at desktop */
        max-width: 34.375rem;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        /* 48px - 64px */
        gap: clamp(3rem, 6vw, 4rem);
    }
    #sbs-1161 .cs-content {
        /* set text align to left if content needs to be left aligned */
        text-align: left;
        width: 100%;
        max-width: 33.875rem;
        display: flex;
        flex-direction: column;
        /* centers content horizontally, set to flex-start to left align */
        align-items: flex-start;
    }

    #sbs-1161 .cs-text {
        margin-bottom: 1rem;
    }
    #sbs-1161 .cs-text:last-of-type {
        margin-bottom: 2rem;
    }
    #sbs-1161 .cs-ul {
        max-width: 39.375rem;
        margin: 0 0 2rem 0;
        padding: 0;
        /* clips the bullets to create the half circle */
        overflow: hidden;
    }
    #sbs-1161 .cs-li {
        list-style: none;
        margin: 0 0 0.5rem 0;
        color: var(--bodyTextColor);
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 0.75rem;
        position: relative;
    }
    #sbs-1161 .cs-li:before {
        /* bullet */
        content: "";
        width: 0.5rem;
        height: 0.5rem;
        margin-top: 0.5rem;
        background: var(--secondary);
        display: block;
        /* prevents flexbox from squishing it */
        flex: none;
    }
    #sbs-1161 .cs-button-solid {
        font-size: 1rem;
        /* 46px - 56px */
        line-height: clamp(2.875rem, 5.5vw, 3.5rem);
        text-decoration: none;
        font-weight: 700;
        text-align: center;
        margin: 0;
        color: #fff;
        min-width: 9.375rem;
        padding: 0 1.5rem;
        background-color: var(--primary);
        display: inline-block;
        position: relative;
        z-index: 1;
        /* prevents padding from adding to the width */
        box-sizing: border-box;
    }
    #sbs-1161 .cs-button-solid:before {
        content: "";
        position: absolute;
        height: 100%;
        width: 0%;
        background: #000;
        opacity: 1;
        top: 0;
        left: 0;
        z-index: -1;
        transition: width 0.3s;
    }
    #sbs-1161 .cs-button-solid:hover:before {
        width: 100%;
    }
    #sbs-1161 .cs-image-group {
        /* scales the whole group based on the view width size and stop when that vales equals .8em, resets at desktop */
        font-size: min(2.15vw, 0.8em);
        width: 42.375em;
        height: 36.75em;
        display: block;
        position: relative;
        z-index: 1;
    }
    #sbs-1161 .cs-picture {
        position: absolute;
    }
    #sbs-1161 .cs-picture img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
    }
    #sbs-1161 .cs-picture1 {
        width: 39.375em;
        height: 24.375em;
        top: 0;
        left: 0;
        z-index: 10;
    }
    #sbs-1161 .cs-picture2 {
        width: 28.8125em;
        height: 18.75em;
        bottom: 0;
        right: 0;
        z-index: 10;
    }
    #sbs-1161 .cs-graphic {
        height: auto;
        position: absolute;
    }
    #sbs-1161 .cs-graphic1 {
        width: 72.125em;
        top: 1.25em;
        right: -3.75em;
        transform: rotate(-15deg);
    }
    #sbs-1161 .cs-graphic2 {
        width: 67.8125em;
        top: 11.5625em;
        right: -1.5625em;
    }
    #sbs-1161 .cs-box {
        width: 12.3125em;
        height: 11.125em;
        padding: 0.5rem;
        /* prevents padding and border from affecting height and width */
        box-sizing: border-box;
        background-color: var(--primary);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: absolute;
        z-index: 20;
        left: 0;
        bottom: 0;
    }
    #sbs-1161 .cs-number {
        /* 20px - 39px */
        font-size: clamp(1.25rem, 4vw, 2.4375rem);
        text-align: center;
        line-height: 1.2em;
        font-weight: 700;
        width: 100%;
        /* 4px - 8px */
        margin: 0 0 clamp(0.25rem, 1vw, 0.5rem);
        color: var(--bodyTextColorWhite);
        display: block;
    }
    #sbs-1161 .cs-desc {
        /* 12px - 16px */
        font-size: clamp(0.75rem, 1.9vw, 1rem);
        text-align: center;
        line-height: 1.2em;
        font-weight: 700;
        width: 100%;
        max-width: 12ch;
        margin: 0;
        color: var(--bodyTextColorWhite);
        display: block;
    }
}
/* Small Desktop - 1024px */
@media only screen and (min-width: 64rem) {
    #sbs-1161 .cs-container {
        max-width: 80rem;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    #sbs-1161 .cs-image-group {
        font-size: min(1.2vw, 1em);
        flex: none;
    }
}

</style>
